<template>
    <div
        class="feed-card-extension"
        @click="selectFeed"
    >
        <feed-card
            class="dashboard-feed-card"
            :class="[otherPropValue.selectedFeed !== null && otherPropValue.selectedFeed.uid === source.uid ? 'selected-element' : '']"
            :feed="source"
            :display-config-button="false"
            :universes="otherPropValue.universes"
            :events="otherPropValue.events"
            :configurations="otherPropValue.configurations"
            :defaultPreviewImageUrl="otherPropValue.defaultPreviewImageUrl"
            :unMutedFeedsUid="otherPropValue.unMutedFeedsUid"
            :feed-resources="otherPropValue.feedResources"
            dashboardCard
        ></feed-card>
        <i
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : otherPropValue.selectedFeed !== null && otherPropValue.selectedFeed.uid === source.uid}"
        ></i>
    </div>
</template>

<script>

import { FeedCard } from 'gcmcn-common';
export default {

    components: {
        FeedCard,
    },


    props: {
        index: {
            type: Number,
            required: true,
        },
        source: {
            type: Object,
            default () {
                return {};
            }
        },
        otherPropValue: {
            type: Object,
        }
    },

    data (){
        return {

        };
    },

    computed: {

    },

    created (){
    },

    methods: {
        selectFeed (){
            this.$parent.$parent.$emit('select-feed', this.source);
        },
    },
};
</script>

<style lang="scss">

    .feed-card-extension{
        position: relative;
        background-color: #222;
        display: flex;
        align-items: center;
        color: #bbb;
        .play-btn {
            border-width: 15px 0 15px 26px !important;

        }
        .pause-btn {
            div {
                height: 30px !important;
                width: 10px !important;
                &+div {
                    margin-left: 5px !important;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/feed-card.vue